// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"leftSidebar_sidebar__rPr_6","submenu":"leftSidebar_submenu__ibXOy"};